import React from "react";
import { NavLink } from "react-router";

interface Props {
  path: string;
  label: string;
  iconClassName: string;
  exact?: boolean;
}

const MenuBarItem: React.FC<Props> = ({ label, path, iconClassName }: Props): JSX.Element => {
  return (
    <li>
      <NavLink
        to={path}
        className={({ isActive }) => (isActive ? "navlink-active caprx-menu-bar-item" : "caprx-menu-bar-item")}
      >
        <span aria-hidden="true" className={iconClassName}></span>
        <span>{label}</span>
      </NavLink>
    </li>
  );
};

export default MenuBarItem;
